var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43562",
    "data-name": "Group 43562",
    transform: "translate(121 -1568)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14649",
    "data-name": "Rectangle 14649",
    width: 24,
    height: 24,
    transform: "translate(-121 1568)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "info",
    transform: "translate(-119.5 1569.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33382",
    "data-name": "Path 33382",
    d: "M12.715,10.983a.733.733,0,0,0-1.465,0v5.86a.733.733,0,0,0,1.465,0Z",
    transform: "translate(-1.483 -1.459)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33383",
    "data-name": "Path 33383",
    d: "M11.75,1.25a10.5,10.5,0,1,0,10.5,10.5A10.5,10.5,0,0,0,11.75,1.25ZM2.715,11.75a9.035,9.035,0,1,1,9.035,9.035A9.035,9.035,0,0,1,2.715,11.75Z",
    transform: "translate(-1.25 -1.25)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33384",
    "data-name": "Path 33384",
    d: "M12.953,7.977A.977.977,0,1,1,11.977,7,.977.977,0,0,1,12.953,7.977Z",
    transform: "translate(-1.477 -1.384)",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGuide);
export default __webpack_public_path__ + "static/media/user-guide.c1d68b95c76eef5dfd22f1a255facb38.svg";
export { ForwardRef as ReactComponent };